import { createReducer } from '../../utilities';
import { scope, REFRESH_STATS_MPT } from '../../../actions/app/mpt/stats';
import {
    REQUEST_STATS_MPT_USERS,
    SUCCESS_FETCH_STATS_MPT_USERS,
    FAIL_FETCH_STATS_MPT_USERS,
} from '../../../actions/entities/mpt/stats';

const initialStatsMPTUsersStatisticsState = {
    ids: [],
    total: null,
    info: {
        isFetching: false,
        lastPayload: null,
        needRefresh: true,
        updatedAt: null
    }
};

function requestMPTUsersStatistics(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null
        }
    };
}

function successFetchMPTUsersStatistics(state, action) {
    const { total, ids, payload, receivedAt } = action;
    return {
        ...state,
        ids,
        total,
        info: {
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt
        }
    };
}

function failFetchMPTUsersStatistics(state, action) {
    const { errors, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            errors
        }
    };
}

function refreshMPTUsersStatistics(state) {
    return {
        ...state,
        info: {
            ...state.info,
            needRefresh: true
        }
    };
}

export default createReducer(initialStatsMPTUsersStatisticsState, {
    [REQUEST_STATS_MPT_USERS]: requestMPTUsersStatistics,
    [SUCCESS_FETCH_STATS_MPT_USERS]: successFetchMPTUsersStatistics,
    [FAIL_FETCH_STATS_MPT_USERS]: failFetchMPTUsersStatistics,
    [REFRESH_STATS_MPT]: refreshMPTUsersStatistics,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/mpt/userStats.js